<template>
  <div>
    <QCChartResult :selectedStatuses="statuses"></QCChartResult>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const QCChartResult = defineAsyncComponent(() =>
  import("@/components/QCCharts/QCChartResult")
);
export default {
  components: {
    QCChartResult,
  },
  data() {
    return {
      statuses: "COMPLETED",
    };
  },
};
</script>
